/** Navigation and action icons: 16px grid, 1.5px strokes, square caps. */
function Svg({ size = 16, children }: { size?: number; children: React.ReactNode }) {
  return (
    <svg
      viewBox="0 0 16 16"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const Icons = {
  overview: () => (
    <Svg>
      <path d="M2.5 2.5h4.5v4.5h-4.5zM9 2.5h4.5v7H9zM2.5 9h4.5v4.5h-4.5zM9 11.5h4.5v2H9z" />
    </Svg>
  ),
  assets: () => (
    <Svg>
      <path d="M2 3.5h12v9H2z" />
      <path d="M6.5 6v4l3.5-2z" fill="currentColor" stroke="none" />
    </Svg>
  ),
  key: () => (
    <Svg>
      <circle cx="5" cy="10.5" r="2.75" />
      <path d="M7 8.5l6-6M11 4.5l1.75 1.75M9.5 6l1.25 1.25" />
    </Svg>
  ),
  settings: () => (
    <Svg>
      <path d="M2 4.5h6M11 4.5h3M2 11.5h2M7 11.5h7" />
      <circle cx="9.5" cy="4.5" r="1.5" />
      <circle cx="5.5" cy="11.5" r="1.5" />
    </Svg>
  ),
  building: () => (
    <Svg>
      <path d="M3 14V2.5h7V14M10 6.5h3V14M1.5 14h13M5.5 5h2M5.5 8h2M5.5 11h2" />
    </Svg>
  ),
  user: () => (
    <Svg>
      <circle cx="8" cy="5.5" r="2.75" />
      <path d="M2.75 14c.6-2.6 2.7-4 5.25-4s4.65 1.4 5.25 4" />
    </Svg>
  ),
  users: () => (
    <Svg>
      <circle cx="5.75" cy="5.5" r="2.25" />
      <path d="M1.75 13.5c.45-2.2 2-3.25 4-3.25s3.55 1.05 4 3.25" />
      <path d="M10.5 3.5a2.25 2.25 0 0 1 0 4M12 10.5c1.2.4 2.05 1.3 2.25 3" />
    </Svg>
  ),
  book: () => (
    <Svg>
      <path d="M2.5 3h4a1.5 1.5 0 0 1 1.5 1.5V14a1.5 1.5 0 0 0-1.5-1.5h-4zM13.5 3h-4A1.5 1.5 0 0 0 8 4.5V14a1.5 1.5 0 0 1 1.5-1.5h4z" />
    </Svg>
  ),
  external: () => (
    <Svg size={12}>
      <path d="M6 3H3v10h10v-3M9 3h4v4M13 3 7.5 8.5" />
    </Svg>
  ),
  signOut: () => (
    <Svg>
      <path d="M6 2.5H3v11h3M10.5 5l3 3-3 3M13.5 8H6.5" />
    </Svg>
  ),
  plus: () => (
    <Svg>
      <path d="M8 3v10M3 8h10" />
    </Svg>
  ),
  upload: () => (
    <Svg>
      <path d="M8 10.5V2.5M4.75 5.75 8 2.5l3.25 3.25M2.5 10v3.5h11V10" />
    </Svg>
  ),
  chevronDown: () => (
    <Svg size={12}>
      <path d="M3.5 6l4.5 4.5L12.5 6" />
    </Svg>
  ),
};
